<div class="form-field" [ngClass]="{'no-legend' : !hasLabel}">
  <fieldset [class.disabled]="disabled"
            [ngClass]="{'no-margin': noMargin}"
            [ngStyle]="{'background' : backgroundColor}"
            [class.large-input]="LargeInput">


    <input [type]="getNativeType()"
           [placeholder]="placeholder"
           [disabled]="disabled"
           [value]="rawInput"
           (input)="handleInputChange($event)"
           (blur)="onBlur()"
           (focus)="onFocus($event)"
           (pointerdown)="onPointerDown()"
           [required]="required"
           [step]="step"
           (keydown)="handleKeyDown($event)"
           autocomplete="off"
           [name]="label"
           [ngClass]="{'search-input': type === 'search'}"
           #nativeInput />

    <span *ngIf="suffix" class="input-suffix">
      {{ suffix }}
    </span>

    <!-- ✅ CLEAR (X) ICON FOR SEARCH -->
    <mat-icon class="input-icon clear" style="color:red; font-weight:bolder"
              *ngIf="type === 'search' && value"
              (click)="clearSearch()"
              title="Clear">
      close
    </mat-icon>

    <!-- ✅ PASSWORD TOGGLE (unchanged) -->
    <mat-icon title="Show Password"
              class="input-icon"
              *ngIf="type === 'password' && value?.length > 0"
              (click)="showPassword = !showPassword">
      {{ showPassword ? 'visibility_off' : 'visibility' }}
    </mat-icon>

    <legend *ngIf="hasLabel" [ngClass]="{'search-label': type === 'search'}">{{ label }}<mat-icon *ngIf="type === 'search'" class="search-icon">search</mat-icon></legend>

    <div class="error text-red" *ngIf="invalid">
      {{ errorMessage }}
    </div>
  </fieldset>
</div>
